var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.76602C7.51982 1.76602 2.26663 7.01921 2.26663 13.4993C2.26663 19.9795 7.51982 25.2327 14 25.2327C20.4801 25.2327 25.7333 19.9795 25.7333 13.4993C25.7333 7.01921 20.4801 1.76602 14 1.76602ZM0.666626 13.4993C0.666626 6.13555 6.63616 0.166016 14 0.166016C21.3638 0.166016 27.3333 6.13555 27.3333 13.4993C27.3333 20.8631 21.3638 26.8327 14 26.8327C6.63616 26.8327 0.666626 20.8631 0.666626 13.4993ZM19.9264 7.95544C20.2683 8.23522 20.3187 8.73924 20.0389 9.0812L12.5346 18.2532C12.3915 18.4281 12.181 18.5344 11.9553 18.5456C11.7295 18.5569 11.5095 18.4721 11.3497 18.3123L8.01445 14.977C7.70203 14.6646 7.70203 14.1581 8.01445 13.8457C8.32687 13.5332 8.8334 13.5332 9.14582 13.8457L11.856 16.5558L18.8006 8.06802C19.0804 7.72606 19.5844 7.67566 19.9264 7.95544Z",
    fill: "#D1005D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/successCircle.a95132a470ecc2b0dac4e77fcd79042a.svg";
export { ForwardRef as ReactComponent };